module.exports = __webpack_public_path__ + "img/facebook.c1e76960.svg";